import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import SpideyLogo from "@/components/SpideyLogo";

export default function PaymentCancel() {
    return (
        <div className="min-h-screen bg-spidey-bg flex flex-col" data-testid="payment-cancel-container">
            <header className="max-w-3xl w-full mx-auto px-5 pt-8">
                <Link to="/">
                    <SpideyLogo />
                </Link>
            </header>

            <main className="flex-1 flex items-center justify-center px-5 py-16">
                <motion.div
                    initial={{ opacity: 0, scale: 0.94 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    className="w-full max-w-lg bg-spidey-card border border-zinc-800 rounded-3xl p-10 text-center"
                >
                    <XCircle size={56} className="mx-auto text-zinc-500" />
                    <h1 className="mt-6 font-display uppercase text-3xl text-white">
                        Paiement annulé
                    </h1>
                    <p className="mt-3 text-sm text-zinc-500 leading-relaxed">
                        Aucun montant n'a été débité. Ta paire t'attend toujours —
                        mais le stock fond vite.
                    </p>
                    <Link
                        to="/"
                        className="mt-9 inline-block bg-spidey-red hover:bg-spidey-neon text-white font-bold uppercase tracking-wider text-sm px-8 py-3.5 rounded-full transition-all hover:scale-105"
                    >
                        Retour à la boutique
                    </Link>
                </motion.div>
            </main>
        </div>
    );
}
